import { createFileRoute, Navigate, Outlet } from '@tanstack/react-router'
import { Analytics } from '@vercel/analytics/react'
import { STORAGE_KEYS } from '~constants'
import Loading from '~containers/general/loading'
import useAnonymousLogin from '~hooks/use-anonymous-login'
import '~themes/samsung-smart-things.scss'

export const Route = createFileRoute('/samsung/smart-things')({
  component: RouteComponent,
  beforeLoad: () => {
    localStorage.setItem(STORAGE_KEYS.ROOT_PATH, '/samsung/smart-things')
  },
  notFoundComponent: () => <Navigate to="/404" />,
})

function RouteComponent() {
  const status = useAnonymousLogin()

  return (
    <>
      <Analytics />
      <div className="w-full h-full no-scrollbar bg-background mx-auto">
        {!status ? <Loading /> : <Outlet />}
      </div>
    </>
  )
}
